import React, { Component } from 'react';
import FormInstall from './FormInstall';

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import FormClient from '../sales/FormClient';
import { initClient, initErrorsResa, initResa } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';


class Form extends Component {
    state = { 
        install: Object.assign({},initResa),
        errors: Object.assign({},initErrorsResa),
        client: Object.assign({},initClient),
        errorsClient: Object.assign({},initClient),
        view: "install",
        numberProd:1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>  // Liste des produits
    }
    
    componentDidMount = () => {
        const { PRODUCTS, SHOPS, install, resaProds } = this.props;
        console.log("componentDidMount",install)

        if (!isEmpty(install)) {
            console.log("Init component with resa",install)
            let newInstall = Object.assign({}, this.state.install)
            newInstall.shop_id = install.shop_id
            newInstall.shop_idDisplay = {
                label: SHOPS[install.shop_id].name, 
                value: install.shop_id,
            }
            newInstall.nature = "installation"
            newInstall.comments =  install.comments
            newInstall.products =  []

            let errors = Object.assign({}, this.state.errors)

            if( PRODUCTS ){
                Object.values(install.products).forEach( (product, i) => {   
                    if (resaProds[product.product_id].reserved > 0 ){
                        let prodInfo = PRODUCTS[product.product_id]    
                        newInstall.products.push(
                            {
                                display: {
                                    value: prodInfo.id, 
                                    label:`${prodInfo.marque} - ${prodInfo.name}`, 
                                } ,
                                product_id: prodInfo.id,
                                quantity: resaProds[product.product_id].reserved,
                            }
                        )
                        
                        errors.products[i] = {
                            product_id: "",
                            quantity: "",
                        }
                    }               
                })
            }

            console.log('====================================');
            console.log({newInstall});
            console.log('====================================');
            this.setState({
                numberProd: newInstall.products.length,
                install: newInstall,
                errors
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        } 
    }


    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            }, () =>{
                this.createAddForm()
            }) 
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                        }
                    ],
                },
                numberProd:1
            }, () =>{
                this.createAddForm()
            }) 
        } else {
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    [name]:value,
                    [displayName]:option
                }
            }, () =>{
                this.createAddForm()
            }) 
        }        
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});
        if (isEmpty(this.props.resa)){
            let value = option.value
            const shop_id = this.state.install.shop_id
            const max = this.findMax(value, shop_id)    

            let cpProducts = this.state.install.products
            cpProducts[index].product_id = value
            cpProducts[index].max = max
            cpProducts[index].display = option
            
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    products:cpProducts,
                }
            }, () =>{
                this.createAddForm()
            })     
        }
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE) => { // return available stock and it's id
        let max = 0

        Object.values(list).map( stock => {            
            if(stock.product_id === product_id  && stock.shop_id === shop_id ){    
                max = stock.quantity
                return                    
            }
        })   
        return max
    }
  
    createProductList = () => {
        const  { AVAILABLE, PRODUCTS } = this.props
        const { install } = this.state;
        const list = [{value: "", label: "Chosissez un Produit"}]

        if(AVAILABLE){
            let selectedProds = install.products.map( prod => prod.product_id)

            Object.values(AVAILABLE).map( stock => {   
                // Un produit désactivé n'est plus proposé au choix, même s'il
                // en reste en stock. Sa fiche reste dans le store : une ligne
                // déjà présente qui le cite continue de s'afficher.
                if (PRODUCTS[ stock.product_id ] && PRODUCTS[ stock.product_id ].is_disabled) return
                let selected = selectedProds.includes(stock.product_id)
                if(stock.shop_id === install.shop_id && stock.quantity > 0){
                    list.push ({
                        value: stock.product_id, 
                        label: `${PRODUCTS[ stock.product_id ].marque} - ${PRODUCTS[ stock.product_id ].name}`, 
                        disabled: selected
                    })
                }
            })
        }
        return list
    }

    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i} >             
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=> this.handleDeleteProd(i)}>
                            <CloseRounded />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.install.products[i].display || {value:"", label:""}}
                            onChange={option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].product_id}
                            label="Produit"
                            placeholder="Selectioner un Produit"
                            // isOptionDisabled={option => option.disabled === true}
                            />    
                        </TableCell> */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.install.products[i].display || {value:"", label:""}}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                        disabled={!isEmpty(this.props.resa)}
                    />

                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.install.products[i].max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.install.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.install.products[i].max ? "Disponible : "+ this.state.install.products[i].max :"" }
                            disabled={!isEmpty(this.props.resa)}
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the install
        console.log("Form Install F ,handleAddProd,")
        const shop_id = this.state.install.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        if (isEmpty(this.props.resa)){
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    products:[
                        ...this.state.install.products,{
                        display:{},
                        product_id:"",
                        quantity:"",
                        max:"",
                    }]
                },
                errors:{
                    ...this.state.errors,
                    products:[
                        ...this.state.errors.products,{                      
                        product_id:"",
                        quantity:"",                    
                    }]
                },
                numberProd:this.state.numberProd+1,
                
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });   
        }
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Install F  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.install.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Install F ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            // L'import ne passe pas par la liste de choix : sans ce refus, un
            // produit désactivé entrerait par le fichier. value[5] est la fiche
            // du store que l'import a appariée à la ligne.
            if (value[5].is_disabled){
                toast.error( "Produit '"+ value[5].name+ "' désactivé : ligne ignorée. Pour le réactiver : Produits, onglet Catalogue, bouton Ajouter")
                return
            }
            const max = this.findMax(value[5].id, shop_id)    
            //Check stock maximal
            if (max<value[2]) {
                toast.error( "Produit '"+ value[5].name+ "' pas de quantite suffisante dans le magasin")
                return
            }
            nbOfProduct++

             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: max
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form Sales ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Sales ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.install.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        if (isEmpty(this.props.resa)){
            cpProducts = [
                ...cpProducts.slice(0,index),
                ...cpProducts.slice(index +1),
            ]
            cpErrors = [
                ...cpErrors.slice(0,index),
                ...cpErrors.slice(index +1),
            ]
            cpProducts.map( prod => {
                if ( prod.priceR && prod.quantity && prod.priceTotal){
                    total += parseFloat(prod.priceTotal)
                }
            }) 
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    products: cpProducts,
                    total,
                },
                errors:{
                    ...this.state.errors,
                    products: cpErrors
                },
                numberProd: this.state.numberProd - 1,
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });   
        }
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.install.products)
            cpProducts[index][name] = value
            if(name === "quantity") {   
                if(value === "" || regex.test(value)){// update value only if its a int
                    this.setState({
                        ...this.state,
                        install:{
                            ...this.state.install,
                            products:cpProducts,
                        }
                    }, () => {
                        // Met à jour la liste produit
                        this.createAddForm()
                    });
                }
                
            } else {
                this.setState({
                    ...this.state,
                    install:{
                        ...this.state.install,
                        products:cpProducts,
                    }
                }, () => {
                    // Met à jour la liste produit
                    this.createAddForm()
                });
            }
                    
        } else {
            this.setState({
                ...this.state,
                install:{
                    ...this.state.install,
                    [field]:value
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        }
    }
    handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        this.setState({
            ...this.state,
            install:{
                ...this.state.install,
                usage_date: selectedDate,
            }
        })
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["cli_type", "cli_typeDisplay", "usage_date"]
        // const notRequired = ["comments", "client_ref", "sale_paygo_id"]
        const notRequiredProdItem = ["max"]

        const install = Object.assign({}, this.state.install)
        Object.keys(install).map( field => {
            console.log(field);
            
            if( isEmpty(install[field]) && !notRequired.includes(field) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                install.products.map((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(notRequiredProdItem.includes(field2)){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });
        if(noErrors){
            this.setState({
                view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }
    validateUpdate = () => {// checks if no error in form before sending it to Back
        let noErrors = true
        let errors = Object.assign({}, this.state.errors)
        let data = Object.assign({}, this.state.purchase)
        let requiredProd = ["product_id", "quantity" ]

        Object.keys(errors).map( field => {
            if(data[field] === "" || data[field] === [] ){// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                data.products.forEach((item, j) => {
                    requiredProd.map( field2 => { // field2 product_id || quantity
                        console.log('====================================');
                        console.log({item, field2, value: item[field2]});
                        console.log('====================================');
                        if( !item[field2] || 
                            item[field2] === 0 || 
                            item[field2] === "0" 
                        ){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else { // not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            // ...this.state,
            errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if (noErrors) {
            
            this.setState({ view: "confirm" })
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }

    validateClient = () => {
        let noErrors = true
        let errors = this.state.errorsClient
        const client = Object.assign({}, this.state.client )

        if(!client.client_paygo_id){
            
            const notRequired = ["client_address", "client_email" ,"id"]
            if(this.state.install.client_ref || this.state.install.cli_type === "mjb"){ // old client with no phone number
                notRequired.push("client_tel")
            }
            if(this.state.install.cli_type !== "mjb"){ // not mjb client so no paygoID
                notRequired.push("client_paygo_id")
            }
            
            Object.keys(client).map( field => {
                if( ( isEmpty(client[field]) && !notRequired.includes(field)) ) { // input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                } else {// not empty
                    errors[field]=""   
                }
            })
            console.log("[INFO] NOERRORS = ",noErrors);
            console.log("[INFO] VALIDATE, ERRORS = ",errors);
            
            this.setState({
                ...this.state,
                errorsClient : errors
            })
        }

        if(noErrors){
            this.setState({
                view:"confirm",
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        // return noErrors
    }
    
    handleSelectClient = (idClient, infoClient, option) => {
        // console.log("SELECT HANDLE",{option});

        let value = idClient || (option?.value)
        let infos = infoClient || option?.infos || {}
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                clientDisplay:option,
                client_lastname:infos.client_lastname || "",
                client_firstname:infos.client_firstname || "",
                client_address:infos.client_address || "",
                client_tel:infos.client_tel || "",
                client_email:infos.client_email || "",
                client_city:infos.client_city || "",
                client_country:infos.client_country || "",
                client_paygo_id:infos.client_paygo_id || "",
                id: value,
            },
            install:{
                ...this.state.install,
                sale_paygo_id: this.state.install.cli_type === "mjb" ? value : "",
                client_ref: this.state.install.cli_type !== "mjb" ? value : "",
            }
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });
    }
    handleSelectClientInfo = (idClient, clientInfo) => {
        if (this.state.client.id === idClient) {
            this.setState({
                ...this.state,
                client: {
                    ...this.state.client,
                    client_address: clientInfo?.adress || this.state.client.client_address,
                    client_tel: clientInfo?.phone || this.state.client.client_tel,
                }
            })
        }
    }

    handleChangeClient =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {
        const { resa} = this.props;
        this.setState({
            sending: true,
        })
        let install = Object.assign({}, this.state.install)
        let client = Object.assign({}, this.state.client)

        install.id = ""
        install.nature = "installation"
        install.unique_id = this.state.uniqueID
        install.date = new Date()
        install.client = client
        install.sale_paygo_id = install.cli_type === "mjb" ? client.id : ""
        install.client_ref = install.cli_type !== "mjb" ? client.id : ""

        if (!isEmpty(resa)) {
            install.resa_demand_id = this.props.resa.id
            install.resa_creator = this.props.resa.user_id
        }

        for (let i = 0; i < install.products.length; i++){
            install.products[i].quantity = parseInt(install.products[i].quantity)                      
        }
            
        await this.props.createInstall(install)
            
        if(this.props.STATE.installs.error){
            console.log("ERROR", this.props.STATE.installs.error);
            this.setState({
                sending: false,
            })
            toast.error( this.props.STATE.installs.error)
        } else {
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Installation enregistrée avec succès")
            this.clearForms()                        
            this.props.closeSubmit ? this.props.closeSubmit() : this.props.handleClose()
        }                
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            install: Object.assign({}, initResa),
            client: Object.assign({}, initClient),
            // errors?
            errors: Object.assign({}, initErrorsResa),
            errorsClient: Object.assign({}, initClient),                
            
        })
    }

    render() {
        const { view, install, client } = this.state;
        console.log("[STATE] NEW INSTALL FORM ",this.state.install);

        const fieldList = [
            {name: "client_lastname", label:"Nom", display: client.client_lastname},
            {name: "client_firstname", label:"Prénom", display: client.client_firstname},
            {name: "client_address", label:"Adresse", display: client.client_address},
            {name: "client_city", label:"Ville", display: client.client_city},
            {name: "client_country", label:"Pays", display: client.client_country},
            {name: "client_tel", label:"Téléphone", display: client.client_tel},
            {name: "client_email", label:"Email", display: client.client_email},
            {name: "shop_id", label:"Magasin", display: install.shop_idDisplay.label},
            {name: "usage_date", label:"Date d'utilisation prévue", display: install.usage_date.toLocaleDateString("fr-FR")},
            {name: "products"}, 
            {name: "totalArt"},  
            {name: "comments", label:"Commentaires", display: install.comments},
        ]
    
        return (
            <React.Fragment>
                {view === "install" &&
                    <div>
                        <FormInstall 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddForm={this.state.form}
                            handleAddProd={this.handleAddProd}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            handleChangeDate={this.handleChangeDate}
                            validate={this.props.update ? this.validateUpdate : this.validate}
                            handleClose={this.props.handleClose}
                            disabled={!isEmpty(this.props.resa)}
                        />
                    </div>
                    }
                {view === "client" &&
                    <PopUp 
                        title="Formulaire Client" 
                        close={() => this.setState({
                            view: "install", 
                            client:initClient, 
                            client_ref: "",
                            sale_paygo_id: "", 
                        })}
                        submitAction={this.validateClient}
                    >
                        <FormClient 
                            {...this.state} 
                            {...this.props}
                            sale={install}
                            handleSelectClient={this.handleSelectClient}
                            handleSelectClientInfo={this.handleSelectClientInfo}
                            handleChangeClient={this.handleChangeClient}
                        />

                    </PopUp>
                    
                }
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "client"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider" 
                    disabledSubmit={this.props.STATE.installs.fetching || this.state.sending}
                    maxWidth="md"
                >
                    <TableLayout>
                        <TableBody>
                            <ConfirmFormTemplate
                                fieldList={fieldList}
                                client={client}
                                transfer={this.state.install}
                            />                     
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;